export const inputLabelStyles = {
  fontSize: '16px',
  color: 'vpColors.black',
  position: 'relative',
  fontWeight: 500,
  left: '-14px',
  top: '-10px',
  '&.Mui-focused': {
    color: 'vpColors.black'
  }
};



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/styles.js